import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import MainLayout from "../../../layouts/MainLayout";
import { useState } from "react";
import DefaultButton from "../../../components/Buttons/Default";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";

function PasswordPhoneNumberPage() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const sendOTP = () => {
    setIsLoading(true);

    fetch(`${API_URL}/password/phone`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ phone_number: phoneNumber }),
    });

    setIsLoading(false);
    navigate('/password_recovery/otp', { state: { phoneNumber } });
  }

  return(
    <MainLayout>
      <section className="auth-section py-5">
        <Container>
          <Row>
            <Col lg="5" md="6" className="mx-auto">
              <div className="text-center">
                <img src={ require('../../../assets/images/logo.png') } height={60} alt="Logo" />
              </div>

              <h3 className="text-center mb-3 mt-5 text-primary fw-normal">إسترجاع كلمة المرور</h3>
              <p className="text-center mb-4">
                بعد كتابة رقم هاتفك. سيصلك رمز تأكيد لجوالك
              </p>

              <div className="bg-white auth-form-container px-4 py-5">
                <FormGroup>
                  <Label>رقم الهاتف: </Label>
                  <Input 
                    type="tel"
                    inputMode="numeric" 
                    value={phoneNumber} 
                    onChange={(e) => setPhoneNumber(e.target.value)} 
                    placeholder="ادخل رقم الهاتف" 
                  />
                </FormGroup>
                <div className="text-center">
                  <DefaultButton 
                    color="primary" 
                    loading={isLoading}
                    disabled={isLoading || phoneNumber?.length < 8}
                    onClick={sendOTP}
                  >
                    إرسال الرمز
                  </DefaultButton>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default PasswordPhoneNumberPage;